import { render, staticRenderFns } from "./returnList.vue?vue&type=template&id=986152a6&scoped=true"
import script from "./returnList.vue?vue&type=script&lang=js"
export * from "./returnList.vue?vue&type=script&lang=js"
import style0 from "./returnList.vue?vue&type=style&index=0&id=986152a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986152a6",
  null
  
)

export default component.exports